import { Form, Badge, Table } from 'react-bootstrap';
import Moment from 'react-moment';
import VerifiedSignature from "../../../../img/documentsign.png";
import { studyMedicalReviewServices } from '../../../../APIServices/studyMedicalReviewServices';
import { useParams } from 'react-router';
import { useEffect, useState, useRef } from 'react';
import MedicalReviewFormDataEntry from '../DataEntryManagement/MedicalReviewFormDataEntry';
import UseToggle from '../../../../Hooks/UseToggle';
import ReviewQueryHistory from './ReviewQueryHistory';

const FormMedicalReviewData = ({ formId }) => {
    const firstName = JSON.parse(localStorage.getItem("firstName"));
    const lastName = JSON.parse(localStorage.getItem("lastName"));
    const studyTabs = JSON.parse(localStorage.getItem("studyTabs"));
    const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
    let { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
    const { studyId } = useParams();

    const [taskList, setTaskList] = useState([]);
    const [taskData, setTaskData] = useState("");

    const apiKeyRef = useRef("");

    const checkData = studyTabs?.find(
        (item) => item.studyTabId === "viewEventSchemaFormLists"
    )?.idObject;

    const getSingleSubjectMedicalReviewer = async () => {
        const data =
            await studyMedicalReviewServices.getSingleSubjectMedicalReviewer(
                studyId,
                checkData?.siteId,
                checkData?.subjectId,
                checkData?.schemaId,
                formId,
                checkData?.eventId,
                checkData?.timePointUniqueId || "no",
                StudyMode
            );

        setTaskList(data?.data || []);
    };

    useEffect(() => {
        if (
            !studyId ||
            !checkData?.siteId ||
            !checkData?.subjectId ||
            !checkData?.schemaId ||
            !formId ||
            !checkData?.eventId
        ) {
            return;
        }
        const currentApiKey = [
            studyId,
            checkData?.siteId,
            checkData?.subjectId,
            checkData?.schemaId,
            formId,
            checkData?.eventId,
            checkData?.timePointUniqueId || "",
        ].join("_");

        if (apiKeyRef.current === currentApiKey) {
            return;
        }

        apiKeyRef.current = currentApiKey;

        getSingleSubjectMedicalReviewer();
    }, [
        studyId,
        formId,
        checkData?.siteId,
        checkData?.subjectId,
        checkData?.schemaId,
        checkData?.eventId,
        checkData?.timePointUniqueId,
    ]);

    return (
        <>
            {taskList?.length > 0 &&
                <Form.Group id="footer" className="mb-2 bg-white">
                    <div className="bg-light border rounded p-2 mt-4 position-relative">
                        <Badge
                            className="position-absolute text-muted bg-success-subtle br3"
                            style={{ top: -10, left: 20 }}
                        >
                            Medical Review
                        </Badge>
                        {taskList?.map((item, index) => (
                            <div key={index} className="p-2 pt-3">
                                <Table
                                    bordered
                                    className="m-0 border signTable bg-white"
                                    style={{ verticalAlign: "middle" }}
                                >
                                    <tbody>
                                        <tr>
                                            <td
                                                className="text-end"
                                                style={{ width: 150 }}
                                            >
                                                {item?.status === "completed" ? "Review Now" : "Reviewed By"}:
                                            </td>

                                            <td>
                                                {firstName} {lastName || ""}
                                            </td>

                                            <td className="p-3">
                                                {item?.status === "completed" ?
                                                    <div
                                                        className="border border-2 rounded-start border-success border-end-0 position-relative"
                                                        style={{ maxWidth: "fit-content" }}
                                                    >
                                                        <div className="p-3">
                                                            <div className="hstack gap-2">
                                                                <h6 className="m-0 fw-bold">
                                                                    {item?.assignToFirstName}
                                                                    <br />
                                                                    {item?.assignToLastName}
                                                                </h6>

                                                                <div>
                                                                    <p
                                                                        className="m-0"
                                                                        style={{ fontSize: 9 }}
                                                                    >
                                                                        Digitally signed by
                                                                        <br />
                                                                        {item?.assignToFirstName} {item?.assignToLastName || ""}
                                                                    </p>

                                                                    <p
                                                                        className="m-0"
                                                                        style={{ fontSize: 9 }}
                                                                    >
                                                                        Date:
                                                                        <Moment
                                                                            format="DD/MM/YYYY"
                                                                            withTitle
                                                                        >
                                                                            {item?.completedDT}
                                                                        </Moment>
                                                                        |
                                                                        <br />
                                                                        <Moment
                                                                            format="HH:mm:ss"
                                                                            withTitle
                                                                        >
                                                                            {item?.completedDT}
                                                                        </Moment>
                                                                        - GMT+06:30
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="position-absolute bg-white w-100"
                                                            style={{
                                                                top: -10,
                                                                left: 30,
                                                            }}
                                                        >
                                                            <p className="fw-bold m-0 ps-1">
                                                                eSigned By:
                                                            </p>
                                                        </div>

                                                        <div
                                                            className="position-absolute bg-white w-100"
                                                            style={{
                                                                bottom: -10,
                                                                left: 30,
                                                            }}
                                                        >
                                                            <p className="fw-bold m-0 ps-1">
                                                                {item?.signatureHash}
                                                            </p>
                                                        </div>

                                                        <img
                                                            className="position-absolute"
                                                            style={{
                                                                top: 8,
                                                                left: 47,
                                                                pointerEvents: "none",
                                                                filter: "opacity(0.2)",
                                                                width: 70,
                                                            }}
                                                            src={VerifiedSignature}
                                                            alt="Signed"
                                                        />
                                                    </div>
                                                    :
                                                    <button
                                                        disabled={item?.totalQuery > 0 || !StudyMode?.startsWith("SDV")}
                                                        className="btn btn-outline-secondary p-1 br3 px-3"
                                                        style={{ fontSize: 12 }}
                                                        onClick={() => { setToggle(); setTaskData(item) }}
                                                    >
                                                        Signature
                                                    </button>
                                                }
                                            </td>
                                            <td style={{ width: 75 }} className='m-auto text-center'>
                                                <span className='d-block'>Total Query : {item?.totalQuery}</span>
                                                <button className='updateProfile' style={{ padding: "1px 10px" }} onClick={() => { setToggle1(); setTaskData(item) }}>View</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        ))}
                    </div>
                </Form.Group>
            }
            <MedicalReviewFormDataEntry
                Show={!toggle}
                Hide={setToggle}
                Title="Medical Review"
                taskData={taskData}
                studyId={studyId}
                getSingleSubjectMedicalReviewer={getSingleSubjectMedicalReviewer}
            />
            <ReviewQueryHistory
                Show={!toggle1}
                Hide={setToggle1}
                Title={`Query History`}
                siteId={taskData?.siteId}
                studyId={taskData?.studyId}
                reviewId={taskData?._id}
                getSubjectMedicalReviewer={getSingleSubjectMedicalReviewer}
            />
        </>
    );
};

export default FormMedicalReviewData;